module.exports = __webpack_public_path__ + "static/media/valeruki.095574d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/valeruki.jpg
// module id = 66
// module chunks = 0